import { INITIAL_STATE, type OnboardingState } from '#lib/steps/state';
import { STEP_ORDER } from '#lib/steps/step';
import { ONBOARDING_STORAGE_KEY } from './storage-key';

/**
 * Read the persisted onboarding state, falling back to the initial state when
 * nothing is stored or the stored data can't be parsed.
 */
export const loadOnboardingState = (): OnboardingState => {
  /* v8 ignore next 3 -- SSR guard: window is always defined under the happy-dom test runner */
  if (typeof window === 'undefined') {
    return INITIAL_STATE;
  }
  try {
    const raw = window.sessionStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (!raw) {
      return INITIAL_STATE;
    }
    const merged: OnboardingState = { ...INITIAL_STATE, ...JSON.parse(raw) };
    // A step persisted by an older build (e.g. the removed 'account' step) would
    // hydrate to a step the router can't render. Coerce any unknown step back to
    // the initial one, keeping the rest of the stored answers.
    return STEP_ORDER.includes(merged.currentStep)
      ? merged
      : { ...merged, currentStep: INITIAL_STATE.currentStep };
  } catch {
    return INITIAL_STATE;
  }
};
